import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Divider,
  Button,
  IconButton,
  Paper,
  Modal,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { Add, Delete, ExpandMore } from "@mui/icons-material";

const Faq = ({ faqs = [], onChange, error, touched }) => {
  const [openModal, setOpenModal] = useState(false);
  const [newFaq, setNewFaq] = useState({
    question: "",
    answer: "",
  });

  const handleAddFaq = () => {
    const updatedFaqs = [...faqs, newFaq];
    onChange && onChange(updatedFaqs);
    setNewFaq({ question: "", answer: "" });
    setOpenModal(false);
  };

  const handleDeleteFaq = (indexToRemove) => {
    const updatedFaqs = faqs.filter((_, i) => i !== indexToRemove);
    onChange && onChange(updatedFaqs);
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom>
        FAQs*
      </Typography>

      {/* List of FAQs */}

      {faqs.map((faq, index) => (
        <Accordion key={index} sx={{ mb: 2, position: "relative" }}>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography fontWeight="bold">{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>{faq.answer}</Typography>
            <Box textAlign="right">
              <IconButton onClick={() => handleDeleteFaq(index)}>
                <Delete color="error" />
              </IconButton>
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
      {/* Add FAQ Button */}
      <Button
        startIcon={<Add />}
        // variant="outlined"
        onClick={() => setOpenModal(true)}
      >
        Add FAQ
      </Button>

      {/* Add FAQ Modal */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" mb={2}>
            Add FAQ
          </Typography>

          <TextField
            label="Question"
            value={newFaq.question}
            onChange={(e) =>
              setNewFaq((prev) => ({ ...prev, question: e.target.value }))
            }
            fullWidth
            margin="normal"
          />
          <TextField
            label="Answer"
            value={newFaq.answer}
            onChange={(e) =>
              setNewFaq((prev) => ({ ...prev, answer: e.target.value }))
            }
            fullWidth
            margin="normal"
            multiline
            rows={3}
          />

          <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
            <Button variant="outlined" onClick={() => setOpenModal(false)}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleAddFaq}
              disabled={!newFaq.question || !newFaq.answer}
            >
              Add
            </Button>
          </Box>
        </Box>
      </Modal>

      {error && touched && (
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default Faq;
